import React from 'react'
import {
  Dialog,
  DialogTrigger,
  Modal as AriaModal,
  ModalOverlay,
  Heading,
} from 'react-aria-components'

interface ModalProps {
  isOpen: boolean
  onOpenChange: (isOpen: boolean) => void
  title?: string
  children: React.ReactNode
  size?: 'sm' | 'md' | 'lg' | 'xl'
}

const sizeClasses = {
  sm: 'max-w-sm',
  md: 'max-w-md',
  lg: 'max-w-lg',
  xl: 'max-w-xl',
}

export function Modal({ isOpen, onOpenChange, title, children, size = 'md' }: ModalProps) {
  return (
    <ModalOverlay
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      isDismissable
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm data-[entering]:animate-fade-in data-[exiting]:animate-fade-out"
    >
      <AriaModal
        className={`w-full ${sizeClasses[size]} mx-4 bg-white rounded-xl shadow-2xl outline-none data-[entering]:animate-zoom-in data-[exiting]:animate-zoom-out`}
      >
        <Dialog className="outline-none">
          {({ close }) => (
            <>
              {title && (
                <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200">
                  <Heading
                    slot="title"
                    className="text-lg font-semibold text-gray-900"
                  >
                    {title}
                  </Heading>
                  <button
                    onClick={close}
                    className="p-1 text-gray-400 hover:text-gray-600 transition-colors rounded-md hover:bg-gray-100 cursor-pointer"
                  >
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                    </svg>
                  </button>
                </div>
              )}
              <div className="px-6 py-4">{children}</div>
            </>
          )}
        </Dialog>
      </AriaModal>
    </ModalOverlay>
  )
}

// Simple trigger wrapper if needed
interface ModalTriggerButtonProps {
  children: React.ReactNode
  className?: string
}

export function ModalTriggerButton({ children, className }: ModalTriggerButtonProps) {
  return (
    <DialogTrigger>
      <button className={className}>{children}</button>
    </DialogTrigger>
  )
}
